"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueType = void 0;
var ValueType = /** @class */ (function () {
    function ValueType(uri, label) {
        this.uri = uri;
        this.label = label;
    }
    return ValueType;
}());
exports.ValueType = ValueType;
